import { AppRoutes } from "router/routes";
import { Providers } from "./Providers";

import { HashRouter } from "react-router-dom";
import { useLocaleStore } from "stores/useLocaleStore";
import { Bootstrap } from "./Bootstrap";
import ErrorBoundary from "./ErrorBoundary";
import { ErrorGuard } from "./ErrorGaurd";
import { Overlays } from "./Overlays";

import "./styles/animation.css";
import "./styles/index.css";

/**
 * App
 * -----------------------------------------
 * 앱의 전역 구조를 구성하는 최상위 컴포넌트
 * - Providers: 전역 컨텍스트 공급
 * - ErrorBoundary: 예기치 못한 렌더링 오류 방어
 * - ErrorGuard: 서버 오류 감시 및 오류 페이지 렌더링
 * - HashRouter: 라우팅 시스템
 * - Bootstrap: 초기 1회 전역 세팅
 * - Overlays: 전역 오버레이(UI)
 */
const App = () => {
  const { locale, isResourceTestMode } = useLocaleStore();

  return (
    <Providers>
      {/* 렌더링 오류(Chunk/Runtime) 방어 */}
      <ErrorBoundary>
        {/* 서버에서 전달되는 오류코드 처리 */}
        <ErrorGuard>
          {/* 라우팅 컨텍스트 */}
          <HashRouter>
            {/* 앱 초기 전역 세팅 (언어/스타일/권한 등) */}
            <Bootstrap>
              {/* 전역 모달/토스트 등 오버레이 */}
              <Overlays />
              {/* 라우트 매핑 */}
              {/* 임시 테스트용 코드 */}
              <AppRoutes
                key={`${locale}-${isResourceTestMode ? "TEST" : ""}`}
              />
            </Bootstrap>
          </HashRouter>
        </ErrorGuard>
      </ErrorBoundary>
    </Providers>
  );
};

export default App;
